module.exports = __webpack_public_path__ + "static/media/feedback.315a7bd1.png";